import {
  Box,
  Collapse,
  TableCell,
  TableRow,
  Typography,
} from "@material-ui/core";
import React, { useState, useEffect, useContext, useRef, memo, useMemo } from "react";

import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import ReorderIcon from "@material-ui/icons/Reorder";
import {
  Button,
  Form,
  Spinner,
} from "react-bootstrap";
import { Tooltip, Dropdown } from "antd";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import { MaterialTableLineItems } from "./MaterialTableLineItems";
import SingleLegGroupRow from "./SingleLegGroupRow";
import {
  basketAction,
  updateBasketAction,
  getBasketAction,
  updateBasketNameAction,
  placeOrdersAction,
  positionsAction,
  positionsActionDis
} from "../../../../redux/actions/brokerAction";
import { useDispatch, useSelector } from "react-redux";
import AppContext from "../../../../context/Context";
import TurnedInNotIcon from '@mui/icons-material/TurnedInNot';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import SaveIcon from '@mui/icons-material/Save';
import PlusMinQty from "../../../utilities/PlusMinQty";
import {
  deleteCookieCredentials,
  getLocalStorageObject,
  setLocalStorageObject,
  calculatePrice,
  sortPosition,
  exitOrder,
  fmtINR,
  fmt
} from "../../../../util/helper";
import moment from "moment";
import ConfirmPopup from "../../../common/ConfirmPopup";
import SLTPModal from "../position-comp/SLTPModal";
import editicon from '../../../../assets/icons/edit.svg';
import deleteicon from '../../../../assets/icons/cancel.svg';
import Item from "antd/es/list/Item";
import { Bolt, ChevronsDown, ChevronsDownUp, ChevronsUp, ChevronsUpDown } from "lucide-react";
import { exitBasketPositionsAction, exitSelectedPositionsAction } from "../../../../redux/actions/packageAction";
import brokerService from "../../../../services/broker.service";
import { useToast } from "components/common/custom-toast/Toast";

let localStorageObj = getLocalStorageObject("positions") || {
  comPrem: {},
};

const initial = {
  name: "",
  stopLossAbsolute: null,
  takeProfitAbsolute: null,
  trailStepAbsolute: null,
  trailReferenceAbsolute: null,
  sltpType: "PNL",
  riskCoverType: 2,
  profitLockAt: null,
  profitLockSl: null
};

const defSLTP = ["Comb Prem", "PNL"];

const ALL_GROUPING_OPTIONS = [
  { key: 'None', label: 'None' },
  { key: 'Instrument', label: 'Instrument' },
  { key: 'Expiry Date', label: 'Expiry Date' },
  { key: 'Strike Price', label: 'Strike Price' },
  { key: 'Buy/Sell', label: 'Buy/Sell' },
];

const MaterialTableGroupRow = ({
  inputValues,
  info,
  source,
  index,
  rowData,
  columns,
  isBasketAdded,
  buySellClick,
  updateBasket,
  isClosedPosition,
  handleChange,
  checkedId,
  totalPNL,
  hoveredRowId,
  setHoveredRowId,
  expandAllTrigger,
  expandAllOpen,
  groupingMode,
  setGroupingMode,
  subGroupingMode,
  setSubGroupingMode,
  basketMargins
}) => {
  const {
    config: { isDark },
    setConfig,
  } = useContext(AppContext);
  const basketSLTP = useSelector((state) => state?.orders);
  const postionList = useSelector((state) => state?.orders?.positions);
  const positionMarge = useSelector((state) => state?.orders?.positionMarge);
  const tickData = useSelector((state) => state?.optionChaininstruments?.tickData);

  const dispatch = useDispatch();
  const valuRef = useRef();
  const [open, setOpen] = useState(false);
  const [show, setshow] = useState(false);
  const [isEditSLTP, seteditSLTP] = useState(false);
  const [formData, setFormData] = useState(initial);
  const [editFieldsName, seteditFieldsName] = useState("");
  const [isBasketFieldID, setisBasketFieldID] = useState("");
  const [basketName, setbasketName] = useState("");
  const [basketNameUpdated, setbasketNameUpdated] = useState(true);
  const [priceType, setpriceType] = useState(0);
  const [isModify, setisModify] = useState("");
  const [isError, seterror] = useState("");
  const [isType, setisType] = useState("");
  const [popUpData, setpopUpData] = useState({});
  const [headersValue, setheadersValue] = useState({
    basketName: "",
    totalPNL: 0,
    tolUnrealizedPNL: 0,
    totaLrealizedPNL: 0,
    stotalPNL: 0,
    stolUnrealizedPNL: 0,
    stotaLrealizedPNL: 0,
    combPrem: 0,
    profitLockAt: 0,
    profitLockSl: 0,
    profitLockTrailRef: 0,
    profitLockTrailStep: 0,
    margin: 0,
    roi: 0,
  });
  const [localPerLot, setLocalPerLot] = useState(null);
  const toast = useToast();

  const nestedGroupingMenuItems = useMemo(() => {
    const noneItem = { key: 'None', label: 'None' };
    const nested = ALL_GROUPING_OPTIONS
      .filter(opt => opt.key !== 'None')
      .map(opt => ({
        key: opt.key,
        label: opt.label,
        children: [
          { key: `${opt.key}__none`, label: 'No sub-group' },
          { type: 'divider' },
          ...ALL_GROUPING_OPTIONS
            .filter(sub => sub.key !== 'None' && sub.key !== opt.key)
            .map(sub => ({ key: sub.key, label: sub.label })),
        ],
      }));
    return [noneItem, ...nested];
  }, []);

  const handleGroupingMenuClick = ({ key, keyPath }) => {
    if (key === 'None') {
      setGroupingMode('None');
      setSubGroupingMode('None');
    } else if (key.endsWith('__none')) {
      setGroupingMode(keyPath[1]);
      setSubGroupingMode('None');
    } else {
      setGroupingMode(keyPath[1]);
      setSubGroupingMode(key);
    }
  };

  const groupingButtonLabel = useMemo(() => {
    if (groupingMode === 'None') return 'Group by';
    if (subGroupingMode !== 'None') return `${groupingMode} → ${subGroupingMode}`;
    return groupingMode;
  }, [groupingMode, subGroupingMode]);

  const getGroupKey = (item, mode) => {
    if (mode === "Instrument") return item.instrument?.name || "Unknown";
    if (mode === "Expiry Date") return item.instrument?.expiry ? moment(item.instrument.expiry).format("DD-MMM-YY") : "Unknown";
    if (mode === "Strike Price") return item.instrument?.strikePrice ? fmt(item.instrument.strikePrice) : "Unknown";
    if (mode === "Buy/Sell") return item.netQuantity > 0 ? "Buy" : (item.netQuantity < 0 ? "Sell" : "Closed");
    return "Other";
  };

  const groupedSingleLegs = useMemo(() => {
    if (rowData.basketId !== "undefined" || groupingMode === "None") return null;

    const buildGroups = (items, mode) => {
      const map = {};
      items.forEach(item => {
        const key = getGroupKey(item, mode);
        if (!map[key]) {
          map[key] = { name: key, data: [], totalPNL: 0, tolUnrealizedPNL: 0, totaLrealizedPNL: 0 };
        }
        map[key].data.push(item);
        map[key].totalPNL += parseFloat(item.totalPNL || 0);
        map[key].tolUnrealizedPNL += parseFloat(item.unrealizedPNL || 0);
        map[key].totaLrealizedPNL += parseFloat(item.realizedPNL || 0);
      });

      const orderMap = { "Sell": 1, "Buy": 2, "Closed": 3 };
      return Object.values(map).sort((a, b) => {
        if (orderMap[a.name] && orderMap[b.name]) {
          return orderMap[a.name] - orderMap[b.name];
        }
        return a.name > b.name ? 1 : -1;
      });
    };

    const result = buildGroups(rowData.data, groupingMode);

    if (subGroupingMode !== "None") {
      result.forEach(group => {
        group.subGroups = buildGroups(group.data, subGroupingMode);
      });
    } else {
      result.forEach(group => { group.subGroups = null; });
    }

    return result;
  }, [rowData.data, groupingMode, subGroupingMode]);

  useEffect(() => {
    if (rowData && rowData.basketId !== "undefined") {
      setOpen(expandAllOpen);
    }
  }, [expandAllTrigger, expandAllOpen]);

  useEffect(() => {
    if (rowData && rowData.data) {
      const defrows = rowData.data;
      var basketName = "";
      var basketId = "";
      var totalPNL = 0;
      var tolUnrealizedPNL = 0;
      var totaLrealizedPNL = 0;
      var stotalPNL = 0;
      var stolUnrealizedPNL = 0;
      var stotaLrealizedPNL = 0;
      var buyPremium = 0;
      var sellPremium = 0;
      var quantity = 0;
      const basketSL = (basketSLTP?.basketSLTP || []).find((item) => item.id === rowData.basketId);
      const usePerLot = localPerLot !== null ? localPerLot : !!basketSL?.rms?.perLot;

      for (let i = 0; i < defrows.length; i++) {
        basketName = defrows[i].basketName ? defrows[i].basketName : "Positions";
        basketId = defrows[i].basketId ? defrows[i].basketId : "Positions";

        totalPNL += parseFloat(defrows[i].totalPNL);
        tolUnrealizedPNL += parseFloat(defrows[i].unrealizedPNL);
        totaLrealizedPNL += parseFloat(defrows[i].realizedPNL);

        if (defrows[i].netQuantity != 0) {
          const leg = defrows[i];
          const netQty = parseFloat(leg.netQuantity || 0);
          const qty = Math.abs(netQty);
          const lotSize = parseFloat(leg.instrument?.lotSize);
          const lots = lotSize > 0 ? qty / lotSize : qty;
          const ltp = parseFloat(leg.ltp || 0);
          const side = leg.transactionType
            ? String(leg.transactionType).toUpperCase()
            : (netQty < 0 ? "SELL" : netQty > 0 ? "BUY" : null);

          quantity += netQty;
          if (lots > 0 && side) {
            if (usePerLot) {
              if (side === "BUY") {
                buyPremium += ltp;
              } else if (side === "SELL") {
                sellPremium += ltp;
              }
            } else {
              if (side === "BUY") {
                buyPremium += ltp * lots;
              } else if (side === "SELL") {
                sellPremium += ltp * lots;
              }
            }
          }
        }

        if (!defrows[i].basketId) {
          stotalPNL += parseFloat(defrows[i].totalPNL);
          stolUnrealizedPNL += parseFloat(defrows[i].unrealizedPNL);
          stotaLrealizedPNL += parseFloat(defrows[i].realizedPNL);
        }
      }
      const combPrem = buyPremium - sellPremium;

      setheadersValue(prev => ({
        ...prev,
        basketName,
        basketId,
        totalPNL,
        tolUnrealizedPNL,
        totaLrealizedPNL,
        stotalPNL,
        stolUnrealizedPNL,
        stotaLrealizedPNL,
        combPrem,
        roi: prev.margin > 0 ? (totalPNL / prev.margin) * 100 : 0
      }));

      getBasketFun(rowData.basketId);
    }

    document.addEventListener("click", function (event) {
      if (!event.target.id) {
        setisBasketFieldID("");
      }
    });
  }, [rowData, totalPNL, localPerLot]);

  useEffect(() => {
    if (rowData.basketId && basketMargins) {
      const margin = basketMargins[rowData.basketId] ?? 0;
      setheadersValue(prev => ({
        ...prev,
        margin: margin,
        roi: margin > 0 ? (prev.totalPNL / margin) * 100 : 0
      }));
    }
  }, [basketMargins, rowData.basketId]);

  useEffect(() => {
    const basketSL = basketSLTP?.basketSLTP?.filter((item) => item.id === rowData.basketId)[0];

    if (basketSL && Object.keys(basketSL).length > 0) {
      const rms = basketSL.rms || {};
      const stopLossValue = rms.stopLossInput?.value || rms.stopLoss;
      const takeProfitValue = rms.takeProfitInput?.value || rms.takeProfit;
      const trailRef = rms.trailSL?.reference;
      const trailStep = rms.trailSL?.step;
      const value = {
        ...formData,
        stopLossAbsolute: stopLossValue == 0 ? 0 : stopLossValue,
        takeProfitAbsolute: takeProfitValue == 0 ? 0 : takeProfitValue,
        stopLossPrice: rms.stopLoss,
        targetPrice: rms.takeProfit,
        trailReferenceAbsolute: trailRef,
        trailStepAbsolute: trailStep,
        sltpType: rms.basis === 2 ? "Underlying" : (rms.basis === 1 ? "Comb Prem" : "PNL"),
        profitLockAt: rms.profitLockAt,
        profitLockSl: rms.profitLockSl,
        profitLockTrailRef: rms.profitLockTrail?.reference,
        profitLockTrailStep: rms.profitLockTrail?.step,
        slValueType: rms.stopLossInput?.valueType,
        tpValueType: rms.takeProfitInput?.valueType,
        trailValueType: rms.trailSL?.valueType,
        perLot: !!rms.perLot,
      };

      valuRef.current = value;
      setFormData(value);
    }
  }, [basketSLTP, rowData, totalPNL]);

  const handleFieldChange = (val, name, headersValue) => {
    if (name === "sltpType") {
      const comPrem = getLocalStorageObject("positions")?.comPrem;
      var jsonCP = [];
      if (comPrem && comPrem.length > 0) {
        const filtercomPremIndex = comPrem.findIndex((item) => item.basketId === headersValue.basketId);
        if (filtercomPremIndex != -1) {
          comPrem[filtercomPremIndex].val = val;
          jsonCP = comPrem;
        } else {
          jsonCP = [...comPrem, { basketId: headersValue.basketId, val: val }];
        }
      } else {
        jsonCP = [{ basketId: headersValue.basketId, val: val }];
      }

      setLocalStorageObject('positions', "comPrem", jsonCP, localStorageObj);
      if (val === "Comb Prem") {
        setshow(true);
      }
    }

    const value = {
      ...formData,
      [name]:
        name === "sltpType" || val === "basketName"
          ? val
          : !val ? val : parseFloat(val),
      name: headersValue.basketName,
    };
    setFormData(value);
  };

  const updateBasketFun = async (value, basketId) => {
    await dispatch(updateBasketAction(basketId, value));
  };

  const getBasketFun = async (basketId) => {
    if (basketId != "undefined") {
      var comp = "PNL";
      const comPrem = getLocalStorageObject("positions")?.comPrem;
      if (comPrem && comPrem.length > 0) {
        const filter = comPrem.filter((item) => item.basketId === basketId);
        if (filter.length > 0) {
          comp = filter[0].val;
        }
      }
      const value = { sltpType: comp };
      valuRef.current = value;
      setFormData(value);
    }
  };

  const handleKeyDown = (e, index, row) => {
    if (e.key === "Enter") {
      seteditFieldsName("");
    }
  };

  const editField = (type, rowData) => {
    if (!isValidsltp("sl", parseFloat(formData.stopLossAbsolute), rowData)) return;
    if (!isValidsltp("tp", parseFloat(formData.takeProfitAbsolute), rowData)) return;
    setisModify(type);
  };

  const editBasketField = (id, value) => {
    setisBasketFieldID("");
    setisBasketFieldID(id);
    setbasketName(value);
  };

  const handleChangeBasketField = (e) => {
    if (e.key === "Enter") {
      setbasketNameUpdated(false);
      if (headersValue.basketName != e.target.value) {
        updateBasketName({ name: e.target.value }, isBasketFieldID);
        const value = { ...headersValue, basketName: e.target.value };
        setheadersValue(value);
      } else {
        setbasketNameUpdated(true);
        setisBasketFieldID("");
      }
    }
    setbasketName(e.target.value);
  };

  const updateBasketName = async (value, basketId) => {
    const data = await dispatch(updateBasketNameAction(basketId, value));
    if (data.status) {
      toast.success(data.message);
      if (postionList) {
        const updatedList = postionList.map(pos =>
          pos.basketId === basketId ? { ...pos, basketName: value.name } : pos
        );
        dispatch(positionsAction(updatedList));
      }

      if (positionMarge) {
        const updatedMarge = positionMarge.map(group =>
          group.basketId === basketId
            ? { ...group, data: group.data.map(pos => ({ ...pos, basketName: value.name })) }
            : group
        );
        dispatch(positionsActionDis(updatedMarge));
      }

    }
    setbasketNameUpdated(true);
    setisBasketFieldID("");
  };

  const priceClick = (type) => {
    var isType = 0;
    if (type === 0) isType = 1;
    else if (type === 1) isType = 2;
    else if (type === 2) isType = 0;
    setpriceType(isType);
    setFormData({ ...formData, riskCoverType: isType });
  };

  const modifysltp = (type, rowData) => {
    if (type === "modify") {
      setisModify(true);
    } else if (type === "save") {
      setisModify(false);
      var stopLossPricePr = 0;
      var targetPricePr = 0;

      if (priceType === 0) {
        stopLossPricePr = parseFloat(formData.stopLossAbsolute);
      } else if (priceType === 1) {
        if (rowData.netQuantity > 0) {
          stopLossPricePr = parseFloat(rowData.ltp) - (formData.stopLossAbsolute / 100) * parseFloat(rowData.ltp);
        } else if (rowData.netQuantity < 0) {
          stopLossPricePr = parseFloat(rowData.ltp) + (formData.stopLossAbsolute / 100) * parseFloat(rowData.ltp);
        } else return;
      } else if (priceType === 2) {
        if (rowData.netQuantity > 0) {
          stopLossPricePr = parseFloat(rowData.ltp) - formData.stopLossAbsolute;
        } else if (rowData.netQuantity < 0) {
          stopLossPricePr = parseFloat(rowData.ltp) + formData.stopLossAbsolute;
        } else return;
      }

      if (priceType === 0) {
        targetPricePr = parseFloat(formData.takeProfitAbsolute);
      } else if (priceType === 1) {
        if (rowData.netQuantity > 0) {
          targetPricePr = parseFloat(rowData.ltp) + (formData.takeProfitAbsolute / 100) * parseFloat(rowData.ltp);
        } else if (rowData.netQuantity < 0) {
          targetPricePr = parseFloat(rowData.ltp) - (formData.takeProfitAbsolute / 100) * parseFloat(rowData.ltp);
        } else return;
      } else if (priceType === 2) {
        if (rowData.netQuantity > 0) {
          targetPricePr = parseFloat(rowData.ltp) + formData.takeProfitAbsolute;
        } else if (rowData.netQuantity < 0) {
          targetPricePr = parseFloat(rowData.ltp) - formData.takeProfitAbsolute;
        } else return;
      }

      var value = formData;
      value.stopLossPrice = stopLossPricePr === 0 ? value.stopLossPrice : stopLossPricePr;
      value.targetPrice = targetPricePr === 0 ? value.targetPrice : targetPricePr;
      value.riskCoverType = 0;
      updateBasketFun(value, rowData.basketId, headersValue.basketName);
    } else if (type === "clear") {
      var val = {
        stopLossAbsolute: null,
        takeProfitAbsolute: null,
        trailStepAbsolute: null,
        trailReferenceAbsolute: null,
        riskCoverType: 0,
      };
      updateBasketFun(val, rowData.basketId, headersValue.basketName);
      valuRef.current = val;
      setFormData(val);
    }
  };

  const isValidsltp = (type, val) => {
    if (document.getElementById(rowData.basketId + "-pnl")) {
      var totalPnl = 0;
      if (formData.sltpType === "PNL") {
        totalPnl = document.getElementById(rowData.basketId + "-pnl").innerText?.replace(',', '');
      } else {
        totalPnl = document.getElementById(rowData.basketId + "-comb-prem").innerText?.replace(',', '');
      }
      if (type === "sl") {
        if (parseFloat(totalPnl) < parseFloat(val)) { seterror(type); return false; }
        else { seterror(""); return true; }
      } else {
        if (parseFloat(totalPnl) > parseFloat(val)) { seterror(type); return false; }
        else { seterror(""); return true; }
      }
    } else {
      return false;
    }
  };

  const clearSLofPNL = () => { };
  const handleClose = () => { };

  const editSLTP = (type, row, headersValue) => {
    seteditSLTP(true);
    setpopUpData({ row, headersValue, formData });
  };

  const exitCE = (row, type) => {
    if (type === 'selected' && checkedId?.length > 0) {
      const filterData = row.data.filter(e =>
        checkedId.includes(e.id) && e.instrument?.instrumentType === "CE"
      );
      exitSelectedPositionsAction(info?.broker?.id, filterData.map(pos => pos.id));
    } else if (row.basketId && type === 'multi') {
      exitBasketPositionsAction(row.basketId, "CE");
    } else {
      const positionIds = row.data
        .filter(pos => pos.instrument?.instrumentType === "CE")
        .map(pos => pos.id);
      if (positionIds.length > 0) exitSelectedPositionsAction(info?.broker?.id, positionIds);
    }
  };

  const exitPE = (row, type) => {
    if (type === 'selected' && checkedId && checkedId.length > 0) {
      const filterData = row.data.filter(e =>
        checkedId.indexOf(e.id) != -1 && e.instrument?.instrumentType === "PE"
      );
      exitSelectedPositionsAction(info?.broker?.id, filterData.map(pos => pos.id));
    } else if (row.basketId && type === "multi") {
      exitBasketPositionsAction(row.basketId, "PE");
    } else {
      const positionIds = row.data
        .filter(pos => pos.instrument?.instrumentType === "PE")
        .map(pos => pos.id);
      if (positionIds.length > 0) exitSelectedPositionsAction(info?.broker?.id, positionIds);
    }
  };

  const exitALL = (row, type) => {
    if (row?.basketId && type === 'multi') {
      exitBasketPositionsAction(row?.basketId, "");
    } else {
      const positionIds = row.data.map(pos => pos.id);
      if (positionIds.length > 0) exitSelectedPositionsAction(info?.broker?.id, positionIds);
    }
  };

  const exitSelectedALL = (row, type, checkedId) => {
    const filterData = row.data.filter(e => checkedId.indexOf(e.id) != -1);
    exitSelectedPositionsAction(info?.broker?.id, filterData.map(pos => pos.id));
  };

  const rollStrikesInBasket = (row, ceDirection, peDirection, isSelected = false) => {
    if (!row || !row.data) return;

    const deforders = row.data;
    const allPositionIdsToExit = [];
    const allOrdersToPlace = [];

    const processSide = (positions, direction) => {
      if (!direction || !positions || positions.length === 0) return;

      let activePositions = positions.filter(p => p.netQuantity && p.netQuantity !== 0);
      if (isSelected && checkedId && checkedId.length > 0) {
        activePositions = activePositions.filter(p => checkedId.indexOf(p.id) != -1);
      }
      if (activePositions.length === 0) return;

      allPositionIdsToExit.push(...activePositions.map(p => p.id));

      activePositions.forEach(pos => {
        if (!pos.risk) { console.log("No risk data available for position:", pos); return; }

        const instrumentSide = pos.instrument.instrumentType;
        const lots = Math.abs(pos.netQuantity) / (pos.instrument?.lotSize || 1);
        if (!lots || lots <= 0) return;

        let targetSymbolKey = null;
        if (direction === "up") {
          targetSymbolKey = instrumentSide === "CE" ? 'ceRiskOFFsymbol' : 'peRiskONsymbol';
        } else if (direction === "down") {
          targetSymbolKey = instrumentSide === "CE" ? 'ceRiskONsymbol' : 'peRiskOFFsymbol';
        }

        const riskObj = pos.risk[targetSymbolKey];
        if (!riskObj || Object.keys(riskObj).length === 0) {
          console.log(`No ${direction} strike available for ${instrumentSide} at ${pos.instrument.strikePrice}`);
          return;
        }

        const symbolObj = riskObj || {};
        const targetLtp = pos.riskltp?.[riskObj[instrumentSide]]?.lp;
        if (!targetLtp) { console.log("No LTP available for target strike"); return; }

        const targetLotSize = symbolObj['lotSize-' + instrumentSide] || pos.instrument.lotSize;
        const qty = parseInt(lots) * targetLotSize;
        const addTransactionType = pos.netQuantity > 0 ? "BUY" : "SELL";

        const calculatedPrice = calculatePrice(
          targetLtp,
          inputValues.marketProtect,
          addTransactionType,
          inputValues.orderType,
          inputValues.marketBuffer
        );

        let finalOrderType = inputValues.orderType;
        let finalPrice = calculatedPrice ? parseFloat(calculatedPrice.price) : 0;

        if (
          inputValues.orderType === "Mkt protect" &&
          (inputValues.marketProtect === 0 || (inputValues.marketProtect === undefined && parseFloat(inputValues.marketProtect) === 0))
        ) {
          finalOrderType = "MARKET";
          finalPrice = 0;
        } else {
          finalOrderType = "LIMIT";
        }

        allOrdersToPlace.push({
          exchange: symbolObj['exchange-' + instrumentSide] || pos.instrument.exchange,
          variety: "REGULAR",
          validity: inputValues.validity,
          product: pos.product,
          orderType: finalOrderType,
          transactionType: addTransactionType,
          quantity: qty,
          price: finalPrice,
          exchangeToken: symbolObj['exchangeToken-' + instrumentSide],
          disclosedQuantity: 0,
          stopLossPrice: null,
          targetPrice: null,
          trailReferencePoints: null,
          trailStepPoints: null,
          cellType: instrumentSide,
          lotSize: targetLotSize,
        });
      });
    };

    const cePositions = deforders.filter(item => item?.instrument?.instrumentType === "CE");
    const pePositions = deforders.filter(item => item?.instrument?.instrumentType === "PE");

    if (ceDirection) processSide(cePositions, ceDirection);
    if (peDirection) processSide(pePositions, peDirection);

    if (allPositionIdsToExit.length > 0) {
      exitSelectedPositionsAction(info?.broker?.id, [...new Set(allPositionIdsToExit)]);
    }

    if (allOrdersToPlace.length > 0) {
      const param = {
        basketName: "",
        ignoreBasketMove: true,
        basketId: row.basketId && row.basketId !== "undefined" ? row.basketId : "",
        stopLossAbsolute: null,
        takeProfitAbsolute: null,
        trailReferenceAbsolute: null,
        trailStepAbsolute: null,
        orders: allOrdersToPlace,
      };
      dispatch(placeOrdersAction(param, info?.broker?.id));
    }
  };

  // ─── Render ───────────────────────────────────────────────────────────────
  return (
    <>
      <TableRow
        onMouseEnter={() => setHoveredRowId(rowData.basketId || rowData.id)}
        onMouseLeave={() => setHoveredRowId(null)}
        style={
          rowData.basketId === "undefined"
            ? { marginTop: "3px", paddingBottom: "12px" }
            : { paddingBottom: "12px" }
        }
      >
        <TableCell colSpan={12} style={{ padding: 0, borderBottom: "none" }}>

          {/* ── Basket row header ── */}
          {rowData.basketId != "undefined" && (
            <div
              key={rowData.basketId}
              style={{
                borderBottom: open ? "none" : "",
                borderBottomLeftRadius: open ? "0px" : "",
                borderBottomRightRadius: open ? "0px" : "",
              }}
              className="basket-pnl-div cursor-pointer"
              onClick={() => setOpen(!open)}
            >
              <div className="pe-0 ps-0">
                <button
                  aria-label="expand row"
                  style={{
                    background: 'none', border: 'none', padding: '8px',
                    cursor: 'pointer', display: 'inline-flex',
                    alignItems: 'center', justifyContent: 'center',
                  }}
                >
                  {open
                    ? <KeyboardArrowDownIcon style={{ color: isDark ? "#afb2b6" : "#000" }} />
                    : <KeyboardArrowRightIcon style={{ color: isDark ? "#afb2b6" : "#000" }} />}
                </button>
              </div>

              <div className="ins-name">
                {rowData.data.every(val => val.instrument.name == rowData.data[0].instrument.name)
                  ? rowData.data[0].instrument.name
                  : "Multiple"}
              </div>

              {columns[0]?.strategyHeader.filter(item => item.accessorKey === "basketName" && item.enableColumn).length > 0 && (
                <div className="strategy-container">
                  <div align="left" className="read-val cursor-pointer" key={headersValue.basketName} id={rowData.basketId + "-01"}>
                    {isBasketFieldID !== rowData.basketId ? (
                      <Tooltip placement="top" title={basketName ? basketName : headersValue.basketName} overlayStyle={{ position: 'fixed' }}>
                        <div
                          id={rowData.basketId + "-02"}
                          style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                          onClick={e => { e.stopPropagation(); editBasketField(rowData.basketId, headersValue.basketName); }}
                        >
                          {headersValue.basketName.length >= 29
                            ? headersValue.basketName.substring(0, 29) + "..."
                            : headersValue.basketName}{" "}
                          ({rowData?.data?.filter(item => item.netQuantity != 0)?.length}/{rowData?.data?.length})
                        </div>
                      </Tooltip>
                    ) : (
                      <Form.Group style={{ paddingLeft: 0 }} className="form-group">
                        <Form.Control
                          type="text"
                          placeholder=""
                          name="basketName"
                          min={1}
                          value={basketName}
                          onKeyDown={e => handleChangeBasketField(e)}
                          onChange={handleChangeBasketField}
                          disabled={!basketNameUpdated}
                          id={basketName + "-id"}
                        />
                        {!basketNameUpdated && (
                          <div className="spiner-grow-input">
                            <Spinner animation="border" variant="info" />
                          </div>
                        )}
                      </Form.Group>
                    )}
                  </div>
                </div>
              )}

              {columns[0]?.strategyHeader.filter(item => item.accessorKey === "pnl" && item.enableColumn).length > 0 && (
                <div align="left" className="pos-values pos-pnl-div">
                  <span
                    id={headersValue.basketId + "-pnl"}
                    className={headersValue.totalPNL === 0 ? "" : headersValue.totalPNL > 0 ? "text-success" : "text-danger"}
                  >
                    {headersValue.totalPNL ? fmtINR(headersValue.totalPNL) : 0.00}{" "}
                  </span>
                </div>
              )}

              {columns[0]?.strategyHeader.filter(item => item.accessorKey === "upnl" && item.enableColumn).length > 0 && (
                <div align="left" className="pos-values pos-pnl-div">
                  <span
                    id={headersValue.basketId + "-u"}
                    className={headersValue.tolUnrealizedPNL === 0 ? "" : headersValue.tolUnrealizedPNL > 0 ? "text-success" : "text-danger"}
                  >
                    {headersValue.tolUnrealizedPNL ? fmtINR(headersValue.tolUnrealizedPNL) : 0.00}{" "}
                  </span>
                </div>
              )}

              {columns[0]?.strategyHeader.filter(item => item.accessorKey === "rpnl" && item.enableColumn).length > 0 && (
                <div align="left" className="pos-values pos-pnl-div">
                  <span
                    id={headersValue.basketId + "-r"}
                    className={headersValue.totaLrealizedPNL === 0 ? "" : headersValue.totaLrealizedPNL > 0 ? "text-success" : "text-danger"}
                  >
                    {headersValue.totaLrealizedPNL ? fmtINR(headersValue.totaLrealizedPNL) : 0.00}{" "}
                  </span>
                </div>
              )}

              {/* ROI and Margin */}
              {rowData.basketId !== "undefined" && columns[0]?.strategyHeader.filter(item => item.accessorKey === "margin" && item.enableColumn).length > 0 && (
                <div align="right" className="pos-values pos-pnl-div">
                  <span>{headersValue.margin ? fmtINR(headersValue.margin) : "0.00"}</span>
                </div>
              )}
              {rowData.basketId !== "undefined" && columns[0]?.strategyHeader.filter(item => item.accessorKey === "roi" && item.enableColumn).length > 0 && (
                <div align="right" className="pos-values pos-pnl-div" style={{ minWidth: '100px' }}>
                  <span
                    id={headersValue.basketId + "-roi"}
                    className={headersValue.roi === 0 ? "" : headersValue.roi > 0 ? "text-success" : "text-danger"}
                  >
                    {headersValue.roi ? headersValue.roi.toFixed(2) + "%" : "0.00%"}
                  </span>
                </div>
              )}

              <div style={{ width: checkedId && checkedId.length > 0 ? '374px' : "286px", textAlign: "center" }} className="d-flex btn-exit">
                <Button disabled={rowData?.data?.filter(item => item?.netQuantity != 0 && item?.instrument?.instrumentType === "CE").length == 0} onClick={e => { e.stopPropagation(); exitCE(rowData, checkedId && checkedId.length > 0 ? 'selected' : 'multi'); }} className="text-primary" size="sm" variant="outline-primary" type="button">Exit CE</Button>
                <Button disabled={rowData?.data?.filter(item => item?.netQuantity != 0 && item?.instrument?.instrumentType === "PE").length == 0} onClick={e => { e.stopPropagation(); exitPE(rowData, checkedId && checkedId.length > 0 ? 'selected' : 'multi'); }} className="text-warning" size="sm" variant="outline-warning" type="button">Exit PE</Button>
                <Button disabled={rowData?.data?.filter(item => item?.netQuantity != 0).length == 0} onClick={e => { e.stopPropagation(); exitALL(rowData, 'multi'); }} className="text-danger" size="sm" variant="outline-danger" type="button">Exit All</Button>
                {checkedId && checkedId.length > 0 && (
                  <Button style={{ width: "80px" }} disabled={rowData?.data?.filter(item => item?.netQuantity != 0).length == 0} onClick={e => { e.stopPropagation(); exitSelectedALL(rowData, 'selected', checkedId); }} className="text-danger" size="sm" variant="outline-danger" type="button">Exit Selected</Button>
                )}
                <Tooltip overlayStyle={{ position: 'fixed' }} title="Move In"><Button disabled={rowData?.data?.filter(item => item?.netQuantity != 0).length == 0} className="btn-updown" variant="outline-primary" onClick={e => { e.stopPropagation(); rollStrikesInBasket(rowData, "down", "up", checkedId && checkedId.length > 0); }}><ChevronsDownUp /></Button></Tooltip>
                <Tooltip overlayStyle={{ position: 'fixed' }} title="Move Away"><Button disabled={rowData?.data?.filter(item => item?.netQuantity != 0).length == 0} className="btn-updown" variant="outline-primary" onClick={e => { e.stopPropagation(); rollStrikesInBasket(rowData, "up", "down", checkedId && checkedId.length > 0); }}><ChevronsUpDown /></Button></Tooltip>
                <Tooltip overlayStyle={{ position: 'fixed' }} title="Move Up"><Button disabled={rowData?.data?.filter(item => item?.netQuantity != 0).length == 0} className="btn-updown" variant="outline-primary" onClick={e => { e.stopPropagation(); rollStrikesInBasket(rowData, "down", "down", checkedId && checkedId.length > 0); }}><ChevronsUp /></Button></Tooltip>
                <Tooltip overlayStyle={{ position: 'fixed' }} title="Move Down"><Button disabled={rowData?.data?.filter(item => item?.netQuantity != 0).length == 0} className="btn-updown" variant="outline-primary" onClick={e => { e.stopPropagation(); rollStrikesInBasket(rowData, "up", "up", checkedId && checkedId.length > 0); }}><ChevronsDown /></Button></Tooltip>
              </div>

              <div className={isModify ? "d-flex brokersltp" : "d-flex brokersltp"}>
                {columns[0]?.strategyHeader.filter(item => item.accessorKey === "combinedPremium" && item.enableColumn).length > 0 && (
                  <div align="left" className="basket-form-div p-filled">
                    <span><span id={headersValue.basketId + "-comb-prem"}>{headersValue?.combPrem?.toFixed(2) || 0.00}</span></span>
                  </div>
                )}
                {columns[0]?.strategyHeader.filter(item =>
                  (item.accessorKey === "sl" && item.enableColumn) ||
                  (item.accessorKey === "ta" && item.enableColumn) ||
                  (item.accessorKey === "combinedPremium" && item.enableColumn) ||
                  (item.accessorKey === "trailingSL" && item.enableColumn)
                ).length > 0 && (
                    <div style={{ width: "120px", justifyContent: "center", alignItems: "center", gap: "4px" }} className="cursor-pointer d-flex">
                      <Tooltip placement="top" title="Edit Strategy Risk Settings" overlayStyle={{ position: 'fixed' }}>
                        <Bolt className="risk-settings" strokeWidth={1.5} size={20} onClick={e => { e.stopPropagation(); editSLTP('basket', rowData, headersValue); }} />
                      </Tooltip>
                      <Tooltip placement="top" title="Clear Risk" overlayStyle={{ position: 'fixed' }}>
                        <img src={deleteicon} alt="delete" onClick={e => { e.stopPropagation(); modifysltp('clear', rowData); }} />
                      </Tooltip>
                    </div>
                  )}
                {columns[0]?.strategyHeader.filter(item => item.accessorKey === "sl" && item.enableColumn).length > 0 && (
                  <div align="left" className="basket-form-div p-filled d-flex align-items-center">
                    <span><span>{formData.stopLossPrice ? formData.stopLossPrice === 0 ? 0 : fmtINR(formData.stopLossPrice) : "_"}</span></span>
                  </div>
                )}
                {columns[0]?.strategyHeader.filter(item => item.accessorKey === "ta" && item.enableColumn).length > 0 && (
                  <div align="left" className="basket-form-div p-filled">
                    <span><span>{formData.targetPrice ? formData.targetPrice === 0 ? 0 : fmtINR(formData.targetPrice) : "_"}</span></span>
                  </div>
                )}
                {columns[0]?.strategyHeader.filter(item => item.accessorKey === "trailingSL" && item.enableColumn).length > 0 && (
                  <div align="left" className="basket-form-div p-filled">
                    <span>{formData.trailReferenceAbsolute && formData.trailStepAbsolute ? `${fmtINR(formData.trailReferenceAbsolute)} / ${fmtINR(formData.trailStepAbsolute)}` : "-"}</span>
                  </div>
                )}
                <div align="left" className="basket-form-div p-filled">
                  <span><span>{formData.profitLockAt && formData.profitLockSl ? `${fmtINR(formData.profitLockAt)} / ${fmtINR(formData.profitLockSl)}` : "-"}</span></span>
                </div>
                <div align="left" className="basket-form-div p-filled">
                  <span><span>{formData.profitLockTrailRef && formData.profitLockTrailStep ? `${fmtINR(formData.profitLockTrailRef)} / ${fmtINR(formData.profitLockTrailStep)}` : "-"}</span></span>
                </div>
              </div>
            </div>
          )}

          {/* ── Single leg header ── */}
          {rowData.basketId === "undefined" && (
            <div className="basket-pnl-div d-flex mt-2">
              <div className="pos-heading d-flex align-items-center">
                <p className="p-0 m-0 me-2">Single leg Strategies</p>

                {/* ── Single nested "Group by" dropdown — replaces the two separate dropdowns ── */}
                <Dropdown
                  menu={{
                    items: nestedGroupingMenuItems,
                    onClick: handleGroupingMenuClick,
                  }}
                  trigger={['click']}
                >
                  <Button
                    size="sm"
                    variant={groupingMode !== 'None' ? 'primary' : 'outline-primary'}
                    className="me-4 group-by-btn"
                    onClick={e => e.stopPropagation()}
                  >
                    {groupingButtonLabel}
                    <KeyboardArrowDownIcon style={{ fontSize: '16px', marginLeft: '4px' }} />
                  </Button>
                </Dropdown>

                <div align="left" className="single-leg-pnl">
                  Total PNL:{" "}
                  <span
                    id="single-l-s-pnl"
                    className={`ms-1 ${headersValue.stotalPNL === 0 ? "" : headersValue.stotalPNL > 0 ? "text-success" : "text-danger"}`}
                  >
                    {fmtINR(headersValue.stotalPNL)}{" "}
                  </span>
                </div>
                <div align="left" className="single-leg-pnl">
                  Unrealized:{" "}
                  <span
                    id="single-l-s-u"
                    className={`ms-1 ${headersValue.stolUnrealizedPNL === 0 ? "" : headersValue.stolUnrealizedPNL > 0 ? "text-success" : "text-danger"}`}
                  >
                    {fmtINR(headersValue.stolUnrealizedPNL)}{" "}
                  </span>
                </div>
                <div align="left" className="single-leg-pnl">
                  Realized:{" "}
                  <span
                    id="single-l-s-r"
                    className={`ms-1 ${headersValue.stotaLrealizedPNL === 0 ? "" : headersValue.stotaLrealizedPNL > 0 ? "text-success" : "text-danger"}`}
                  >
                    {fmtINR(headersValue.stotaLrealizedPNL)}{" "}
                  </span>
                </div>
              </div>

              <div style={{ width: checkedId && checkedId.length > 0 ? '262px' : "174px", textAlign: "center" }} className="d-flex btn-exit">
                <Button disabled={rowData?.data?.filter(item => item?.netQuantity != 0 && item?.instrument?.instrumentType === "CE").length == 0} onClick={e => { e.stopPropagation(); exitCE(rowData, checkedId && checkedId.length > 0 ? 'selected' : 'single'); }} className="me-2 text-primary" size="sm" variant="outline-primary" type="button">Exit CE</Button>
                <Button disabled={rowData?.data?.filter(item => item?.netQuantity != 0 && item?.instrument?.instrumentType === "PE").length == 0} onClick={e => { e.stopPropagation(); exitPE(rowData, checkedId && checkedId.length > 0 ? 'selected' : 'single'); }} className="me-2 text-warning" size="sm" variant="outline-warning" type="button">Exit PE</Button>
                <Button disabled={rowData?.data?.filter(item => item?.netQuantity != 0).length == 0} onClick={e => { e.stopPropagation(); exitALL(rowData, 'single'); }} className="me-2 text-danger" size="sm" variant="outline-danger" type="button">Exit All</Button>
                {checkedId && checkedId.length > 0 && (
                  <Button style={{ width: "80px" }} disabled={rowData?.data?.filter(item => item?.netQuantity != 0).length == 0} onClick={e => { e.stopPropagation(); exitSelectedALL(rowData, 'selected', checkedId); }} className="me-2 text-danger" size="sm" variant="outline-danger" type="button">Exit Selected</Button>
                )}
              </div>
            </div>
          )}
        </TableCell>
      </TableRow>

      {/* ── Line items ── */}
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0, borderBottom: "none" }} colSpan={12}>
          {rowData.basketId === "undefined" ? (
            groupingMode === "None" ? (
              <Box className="basket-items" margin={1}>
                <MaterialTableLineItems
                  basketId={rowData.basketId}
                  lineItems={sortPosition(rowData.data, isClosedPosition)}
                  columns={columns}
                  isBasketAdded={isBasketAdded}
                  source={source}
                  info={info}
                  inputValues={inputValues}
                  buySellClick={buySellClick}
                  updateBasket={updateBasket}
                  handleChange={handleChange}
                  checkedId={checkedId}
                  isSingleLeg={true}
                  isDark={isDark}
                />
              </Box>
            ) : (
              groupedSingleLegs.map((group, idx) => (
                <SingleLegGroupRow
                  key={group.name + idx}
                  group={group}
                  columns={columns}
                  isBasketAdded={isBasketAdded}
                  source={source}
                  info={info}
                  inputValues={inputValues}
                  buySellClick={buySellClick}
                  updateBasket={updateBasket}
                  handleChange={handleChange}
                  checkedId={checkedId}
                  isClosedPosition={isClosedPosition}
                  isDark={isDark}
                  groupingMode={groupingMode}
                  subGroupingMode={subGroupingMode}
                />

              ))
            )
          ) : (
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box className="basket-items" margin={1}>
                <MaterialTableLineItems
                  basketId={rowData.basketId}
                  lineItems={sortPosition(rowData.data, isClosedPosition)}
                  columns={columns}
                  isBasketAdded={isBasketAdded}
                  source={source}
                  info={info}
                  inputValues={inputValues}
                  buySellClick={buySellClick}
                  updateBasket={updateBasket}
                  handleChange={handleChange}
                  checkedId={checkedId}
                  isDark={isDark}
                />
              </Box>
            </Collapse>
          )}
        </TableCell>
      </TableRow>

      <ConfirmPopup
        type="com-pre"
        show={show}
        setShow={setshow}
        title="Changing SL/TP Basis for Strategy"
        des={[
          "This action will clear existing Risk Management Settings (Stoploss, Target, TrailingSL).",
          " Are you sure you want to continue?",
        ]}
        clickAction={() => { clearSLofPNL(); setshow(false); }}
        handleClose={() => { handleClose(); setshow(false); }}
      />

      {isEditSLTP && (
        <SLTPModal
          show={isEditSLTP}
          setShow={isFalse => seteditSLTP(isFalse)}
          onSave={(data) => {
            setLocalPerLot(data.perLot);
          }}
          popUpData={popUpData}
          tickData={tickData}
          istype="basket"
          info={info}
        />
      )}
    </>
  );
};

export default memo(MaterialTableGroupRow);